import { render, staticRenderFns } from "./CustomLinks.vue?vue&type=template&id=13ee2fdc&scoped=true&"
import script from "./CustomLinks.vue?vue&type=script&lang=js&"
export * from "./CustomLinks.vue?vue&type=script&lang=js&"
import style0 from "./CustomLinks.vue?vue&type=style&index=0&id=13ee2fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee2fdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
